import React from "react"
import { Box } from "@mui/system"
import { makeStyles } from "tss-react/mui"
import { fetchMerchantsForSupplier, MerchantsResponse, SupplierMerchantsQuery } from "../../../merchants/merchantsApi"
import { useSupplier } from "../../../../supplierHooks"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { ApiQueryAutocomplete } from "../../../../../../core/api/components/ApiQueryAutocomplete"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    input: {
        width: "20rem",
    },
}))

type SelectMerchantProps = Readonly<{
    setMerchantId: (value: string) => void
    // setMerchantId: React.Dispatch<React.SetStateAction<number | undefined>>
    merchantId?: string
}>

function transformData(data: MerchantsResponse) {
    return data.merchants
}

export function SelectMerchantAutocomplete({ setMerchantId, merchantId }: SelectMerchantProps) {
    const { classes } = useStyles()
    const { supplierId } = useSupplier()

    const {
        data = [],
        isLoading,
        isError,
    } = useApiQuery(fetchMerchantsForSupplier, {
        queryName: SupplierMerchantsQuery.MERCHANTS_FOR_SUPPLIER,
        dependencies: {
            supplierId,
        },
        select: transformData,
    })

    return (
        <LocalizedStrict id="accounting-pos-table-header-merchant-label" attrs={{ label: true }}>
            <ApiQueryAutocomplete
                label="Merchant"
                isLoading={isLoading}
                isError={isError}
                disableClearable
                options={data}
                value={merchantId ? data.find((merchant) => merchant.id === +merchantId) : undefined}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                getOptionLabel={(option) => `${option.name}`}
                renderOption={(props, option) => (
                    <Box component="li" sx={{ ml: "0.5rem" }} {...props}>
                        {option.name}
                    </Box>
                )}
                onChange={(_, value) => {
                    setMerchantId(value.id.toString())
                }}
                className={classes.input}
            />
        </LocalizedStrict>
    )
}
